export const prepareTitle = ({ title = '', type = '' } = {}) => {
  const text = title ? title : type;
  return text.charAt(0).toUpperCase() + text.slice(1);
};
